module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Jakob-jongen-foliedruk-afgeronde-hoeken-aquarel-drukwerk-1.6f1ab0a9.jpg";